import {combineReducers} from "redux";

import layoutReducer from "./layout/slice";
import requestDemoReducer from "./requestDemo/slice";

const rootReducer = combineReducers({
    Layout: layoutReducer,
    requestDemo: requestDemoReducer,
})

export default rootReducer;